import '../styles/contribution.css'
import Icon1 from './Icon1.jsx'
import Icon3 from './Icon3.jsx'
import Icon4 from './Icon4.jsx'

function ContributionTitle1() {
    return (
        <div id='contribution_title_display'>
            <div id='contribution_title'>
                <div id='contribution_title_icon'>
                    
                    
                    <Icon4 />
                </div>
                <div id='contribution_title_text'>Contributions</div>
            </div>
        </div>
    )
}

export default ContributionTitle1